import { SET_DEFERRED_SERVICES, CLEAR_SERVICES } from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.deferred, action) {
  switch (action.type) {
    case SET_DEFERRED_SERVICES:
      return action.payload;
    case CLEAR_SERVICES:
    case RESET_APP_STATE:
      return initialState.deferred;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/deferred/reducer.js